import type { KnowledgeItem } from '@/types';

export const weldingKnowledge: KnowledgeItem[] = [
  {
    id: 'w1',
    question: '焊装车间的主要设备有哪些？',
    answer: '主要设备包括：焊接机器人（自动焊接）、车身夹具（固定车身）、传送带（输送车身）、焊缝检测仪（质量检测）、焊接电源（提供能量）、保护气体系统（防止氧化）。',
    tags: ['设备', '概述'],
  },
  {
    id: 'w2',
    question: '焊接电流和电压如何影响焊缝质量？',
    answer: '电流过大：焊缝过宽、烧穿；电流过小：未焊透、夹渣。电压过高：电弧不稳定、飞溅大；电压过低：焊缝窄而高。一般电流160-200A，电压20-25V。',
    tags: ['焊接参数', '质量'],
  },
  {
    id: 'w3',
    question: '机器人焊接速度过快有什么影响？',
    answer: '速度过快会导致：1) 焊缝熔深不足；2) 焊缝宽度变窄；3) 可能出现未熔合缺陷。建议速度控制在0.6-1.0 m/min，根据板厚调整。',
    tags: ['机器人', '速度', '缺陷'],
  },
  {
    id: 'w4',
    question: '夹具夹紧力不足会造成什么问题？',
    answer: '夹紧力不足会导致：1) 焊接变形增大；2) 焊缝间隙不均匀；3) 尺寸精度超差。应定期检查夹具磨损情况，保持夹紧力在4000-6000N。',
    tags: ['夹具', '变形', '精度'],
  },
  {
    id: 'w5',
    question: '焊缝检测不合格怎么处理？',
    answer: '处理步骤：1) 标记缺陷位置；2) 分析缺陷类型（气孔、夹渣、未熔合等）；3) 返修焊接；4) 重新检测。常见原因：保护气体不足、焊丝污染、参数不当。',
    tags: ['检测', '返修', '缺陷'],
  },
];
